import UserHead from '../../components/user/head';

const Page = () => {
  return (
    <UserHead
      title="Page Not Found"
      description="The page you requested does not exist."
    />
  );
};

export default Page;
